 import React from 'react'; 
import config from '../appconfig/config.json';
import helper from '../factory/Helper';

const MaxLoanList = (props) => {

    const {data} = props;
   
    return(
        <div className='inputPair'>
        <div className='tbl-border-grey'>
            <div style={{width:'100%'}}>
                <div className='wd-50-pert item-float-left bg-light-grey br-botm br-rgt'>
                    <div className='loan-title-txt lo-col-hd-hgt'>
                        Loan Tenure
                    </div>
                </div>
                <div className='wd-50-pert item-float-left bg-light-grey br-botm'>
                    <div className='loan-title-txt lo-col-hd-hgt'>
                        Loan Amount
                    </div>
                </div>
            </div>
            {data.map((item, idx) => (
            <div style={{width:'100%'}} key={idx}>
                <div className='wd-50-pert item-float-left br-botm br-rgt'>
                    <div className="loan-txt lo-col-hgt">
                        {'Up to '+item.loanTenure+' years'}
                    </div>
                </div>
                <div className='wd-50-pert item-float-left br-botm'>
                    <div className='loan-txt lo-col-hgt'>
                        {'Up to S$'+helper.formatAmount(item.loanAmount)}
                    </div>
                </div>
            </div>
            ))}
        </div>
        </div>
    )
}

export default MaxLoanList;